import { PERMISSIONS } from "@constants/permissions";

export const getAccess = (roles: string[], roleType: string): boolean => {
  return PERMISSIONS[roleType]?.reduce(
    (prev: boolean, permission: string) =>
      prev || (roles && roles.includes(permission)),
    false,
  );
};
